import React from 'react';
import { LOGIN_HREF, startLogin } from './PublicHeader';

const logo = process.env.PUBLIC_URL + '/img/eunsa-logo.png';
const unsaLogo = process.env.PUBLIC_URL + '/img/unsa.png';

const content = {
    bs: {
        tagline: 'Jedinstveni informacioni sistem Univerziteta u Sarajevu. Razvoj i održavanje — Univerzitetski tele-informatički centar (UTIC).',
        navTitle: 'Navigacija',
        infoTitle: 'Informacije',
        contactTitle: 'Kontakt',
        home: 'Početna',
        login: 'Prijava na sistem',
        mobile: 'Mobilna aplikacija',
        privacy: 'Politika privatnosti',
        unsa: 'Univerzitet u Sarajevu',
        copy: '© 2026 Univerzitet u Sarajevu — UTIC. Sva prava zadržana.'
    },
    en: {
        tagline: 'The Unified Information System of the University of Sarajevo. Developed and maintained by the University Tele-Information Center (UTIC).',
        navTitle: 'Navigation',
        infoTitle: 'Information',
        contactTitle: 'Contact',
        home: 'Home',
        login: 'Sign in',
        mobile: 'Mobile app',
        privacy: 'Privacy Policy',
        unsa: 'University of Sarajevo',
        copy: '© 2026 University of Sarajevo — UTIC. All rights reserved.'
    }
};

export default function PublicFooter({ lang }) {
    const c = content[lang] || content.bs;

    return (
        <footer className="public-footer">
            <style>{`
                .public-footer {
                    --pf-text: #eaf1f8;
                    --pf-muted: #8a97a9;
                    --pf-blue: #5aa1d8;
                    --pf-border: rgba(255, 255, 255, 0.08);
                    position: relative; z-index: 1;
                    border-top: 1px solid var(--pf-border);
                    margin-top: 80px; padding: 52px 0 28px;
                    background: rgba(255, 255, 255, .02);
                    color: var(--pf-text);
                }
                .public-footer .pf-wrap { max-width: 1160px; margin: 0 auto; padding: 0 24px; }

                .public-footer .pf-grid { display: grid; grid-template-columns: 1.6fr 1fr 1fr 1fr; gap: 40px; }
                @media (max-width: 900px) { .public-footer .pf-grid { grid-template-columns: 1fr 1fr; gap: 34px; } }
                @media (max-width: 560px) { .public-footer .pf-grid { grid-template-columns: 1fr; gap: 28px; } }

                .public-footer .pf-logos { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
                .public-footer .pf-logos img { height: 58px; width: auto; border-radius: 7px; }
                .public-footer .pf-logos img.pf-unsa { height: 44px; }
                .public-footer .pf-about p { color: var(--pf-muted); font-size: 14px; max-width: 340px; line-height: 1.65; margin: 0; }

                .public-footer .pf-col { display: flex; flex-direction: column; gap: 10px; font-style: normal; }
                .public-footer .pf-col h4 {
                    font-size: 12px; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase;
                    color: var(--pf-text); margin: 0 0 4px;
                }
                .public-footer .pf-col a { color: var(--pf-muted); text-decoration: none; font-size: 14px; transition: color .2s; width: fit-content; }
                .public-footer .pf-col a:hover { color: var(--pf-blue); }

                .public-footer .pf-bottom {
                    display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap;
                    margin-top: 42px; padding-top: 20px; border-top: 1px solid var(--pf-border);
                }
                .public-footer .pf-bottom p { color: var(--pf-muted); font-size: 13px; opacity: .8; margin: 0; }
                .public-footer .pf-bottom a { color: var(--pf-muted); font-size: 13px; text-decoration: none; opacity: .8; transition: color .2s, opacity .2s; }
                .public-footer .pf-bottom a:hover { color: var(--pf-blue); opacity: 1; }
            `}</style>

            <div className="pf-wrap">
                <div className="pf-grid">
                    <div className="pf-about">
                        <div className="pf-logos">
                            <img src={logo} alt="eUNSA" />
                            <img className="pf-unsa" src={unsaLogo} alt="Univerzitet u Sarajevu" />
                        </div>
                        <p>{c.tagline}</p>
                    </div>

                    <nav className="pf-col">
                        <h4>{c.navTitle}</h4>
                        <a href="/public/landing">{c.home}</a>
                        <a href={LOGIN_HREF} onClick={startLogin}>{c.login}</a>
                    </nav>

                    <nav className="pf-col">
                        <h4>{c.infoTitle}</h4>
                        <a href="/public/mobile">{c.mobile}</a>
                        <a href="/public/privacy-policy">{c.privacy}</a>
                        <a href="https://www.unsa.ba">{c.unsa}</a>
                    </nav>

                    <address className="pf-col">
                        <h4>{c.contactTitle}</h4>
                        <a href="mailto:eunsa@unsa.ba"><span>eunsa@unsa.ba</span></a>
                        <a href="tel:+38733560240"><span>+387 33 560 240</span></a>
                        <a href="https://www.utic.unsa.ba"><span>utic.unsa.ba</span></a>
                    </address>
                </div>

                <div className="pf-bottom">
                    <p>{c.copy}</p>
                    <a href="https://www.eunsa.ba"><span>eunsa.ba</span></a>
                </div>
            </div>
        </footer>
    );
}



// WEBPACK FOOTER //
// ./src/views/Public/PublicFooter.js